// extracted by mini-css-extract-plugin
module.exports = {"container":"EditIcon_container__1TvqJ","editIcon":"EditIcon_editIcon__hyj5Z"};